import { useRef, useEffect } from 'react';

export const usePrevious = (value: any | undefined) => {
  const ref = useRef<string>();
 
  useEffect(() => {
    ref.current = value;
  }, [value]);  
  return ref.current;
};